import BaseService from "./BaseService";

class ChargeInstanceService extends BaseService{


    constructor() {
        super();
        this.serviceUrl = "/api/rest/v2/generic/all/chargeInstance";
    }

    loadAll(filters) {
        return this.opencellAPI.invokeRequest(filters, this.serviceUrl, "POST");
    }
}

const chargeInstanceService = new ChargeInstanceService();

export default chargeInstanceService;


// WEBPACK FOOTER //
// ./src/opencell/services/ChargeInstanceService.js